import {
  ConditionNodeType,
  QueryBuilderEntityValueTokenType,
} from '../../../../../../../../../types';

export const toConditionNode = (
  token: QueryBuilderEntityValueTokenType
): ConditionNodeType => ({
  type: 'condition',
  entityKey: token.entityKey,
  value: token.value,
});
